var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pages-side-bar" },
    [
      _vm._l(_vm.MENU, function(group) {
        return _vm._l(group, function(root) {
          return _c(
            "div",
            { key: root.id, staticClass: "category" },
            [
              _c("a", { attrs: { href: root.url } }, [
                _vm._v(_vm._s(root.name))
              ]),
              _vm._l(
                (root.items || []).reduce(function(acc, items) {
                  return acc.concat(items)
                }, []),
                function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      class: [
                        "subcategory",
                        { active: item.url === _vm.activeCategory }
                      ]
                    },
                    [
                      _c("a", { attrs: { href: item.url } }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]
                  )
                }
              )
            ],
            2
          )
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }